import { useCallback, useEffect, useRef, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  sendAuthCode,
  refreshAuthCodeText,
  SEND_AUTH_CODE,
} from "../../redux/actions/user";

import { Form, Input, Button, Row, Col } from "antd";
import AuthCaptcha from "./AuthCaptcha";

const AuthCodeFormItem = (props) => {
  const captchaRef = useRef(null);
  const [captchaAttempt, setCaptchaAttempt] = useState(0);
  const [captchaStatus, setCaptchaStatus] = useState("loading");

  const sendCodeWithProof = useCallback((captchaVerifyParam) => {
    return props.sendAuthCode({
      phone: `+86${props.phone}`,
      captchaVerifyParam,
    });
  }, [props.phone, props.sendAuthCode]);

  const handleRetryCaptcha = () => {
    setCaptchaAttempt((attempt) => attempt + 1);
  };

  const handleSendCode = () => {
    if (!String(props.phone || "").trim()) {
      return;
    }
    captchaRef.current?.start();
  };

  useEffect(() => {
    const timer = setInterval(() => {
      props.refreshAuthCodeText();
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const codeDisabled = () => {
    return (
      props.request[SEND_AUTH_CODE] ||
      props.codeRemains > 0 ||
      captchaStatus === "verifying"
    );
  };

  const codeButtonText = () => {
    if (captchaStatus === "verifying") {
      return "正在验证";
    }
    return props.codeRemains > 0
      ? `${props.codeRemains}秒后重试`
      : "获取验证码";
  };

  return (
    <Form.Item>
      <Row gutter={8}>
        <Col xs={10} sm={14}>
          <Input
            placeholder="验证码"
            maxLength={6}
            name="code"
            value={props.code}
            onChange={props.onChange}
          />
        </Col>
        <Col xs={14} sm={10}>
          <Button
            type="primary"
            onClick={handleSendCode}
            disabled={codeDisabled()}
            block
          >
            {codeButtonText()}
          </Button>
        </Col>
      </Row>
      <AuthCaptcha
        ref={captchaRef}
        key={captchaAttempt}
        disabled={props.request[SEND_AUTH_CODE] || props.codeRemains > 0}
        onVerified={sendCodeWithProof}
        onRetry={handleRetryCaptcha}
        onStatusChange={setCaptchaStatus}
      />
    </Form.Item>
  );
};

const mapStateToProps = (state) => ({
  codeRemains: state.user.codeRemains,
  request: state.app.request,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      sendAuthCode,
      refreshAuthCodeText,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AuthCodeFormItem);
